<script lang="ts">
    import MainLayout from "src/components/cabinet/#common/layout/Layout.svelte"
    import {Link, navigate} from 'svelte-routing'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte.js'
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.js'
    import backIcon from 'src/components/cabinet/#assets/left-icon.svg'
    import emptyList from './empty.svg'
    import {confirmAction, getNftHistory, isConfirmedAction} from 'src/components/main/#services/marketplace'
    import {showAlert} from 'src/components/#common/alert/store'
    import IconifyIcon from '@iconify/svelte'
    import descriptionIcon from '@iconify/icons-fa-solid/file-alt'
    import infoIcon from '@iconify/icons-fa-solid/info-circle'
    import historyIcon from '@iconify/icons-fa-solid/history'
    import {getEgg, addToMarketPlace, cancelSell, getNft} from 'src/components/cabinet/#services/inventory'
    import {roundNumber} from 'src/components/#common/helpers/helpers'
    import {getMyWallet} from 'src/components/cabinet/#services/nearAdapter'
    import Hatching from 'src/components/cabinet/inventory/components/egg/Hatching.svelte'
    import Timer from 'src/components/cabinet/inventory/components/Timer.svelte'
    import {isLoggedIn, userProfile} from 'src/services/auth'
    import {delay} from 'src/global/delay'

    export let id

    let code
    let type = 'lootbox'
    let opened = false
    let openMintModal = false
    let currentPage = 0
    let perPage = 10
    let sellNftModal = false
    let loading = false
    let minAmount = 1
    let amount
    let hatchingStart = new Date(Date.UTC(2023, 6, 19, 0, 0))
    let hatchingStartInMls = hatchingStart.getTime()
    let now = new Date().getTime()

    getNft.reset()
    init()
    getMyWallet.send()

    async function init() {
        await getNft.send({ data: { productId: id, type } })
        history()
    }

    $: currentPage, history()

    function history() {
        getNftHistory.send({ data: {
            productId: id,
            page: currentPage + 1,
            perPage
        }})
    }

    function getDate(date) {
        date = new Date(date)
        let year = date.toLocaleString("default", {year: "numeric"})
        let month = date.toLocaleString("default", {month: "2-digit"})
        let day = date.toLocaleString("default", {day: "2-digit"})
        return year+"-"+month+"-"+day
    }

    async function sellNftHandler() {
        try {
            loading = true

            await addToMarketPlace.request({ data: {
                productId: id,
                price: amount,
                currency: 'USDT',
                productType: type
            } })

            amount = ''

            showAlert.set({
                status: 'success',
                text: 'You have successfully published your NFT in the marketplace'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            sellNftModal = false
            loading = false
            getNft.reset()
            getNft.send({ data: { productId: id, type } })
        }
    }

    async function cancelSellNftHandler() {
        try {
            loading = true

            await cancelSell.request({ data: { productId: id } })

            showAlert.set({
                status: 'success',
                text: 'NFT sale successfully canceled'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            getNft.reset()
            getNft.send({ data: { productId: id, type } })
        }
    }

    function handleOpened() {
        opened = true
    }

    const keyPressSellNft = e => {
        if (e.charCode === 13 && amount && amount >= minAmount && !loading) sellNftHandler()
    }

    function avatar(nickname) {
        if (nickname) {
            return nickname.slice(0, 2)
        }
    }

    async function confirmActionHandler() {
        try {
            loading = true
            await confirmAction.request({data: {code}})
        } catch (err) {
            console.error(err)
        } finally {
            await delay(300)
            loading = false
            isConfirmedAction.reset()
            isConfirmedAction.send()
        }
    }
</script>

<svelte:head>
{#if !$getNft.hasValue && $getNft.loading}
    <title>Loading...</title>
{:else if !$getNft.hasValue && $getNft.error}
    <title>Something went wrong</title>
{:else if $getNft.hasValue}
    <title>Egg #{id.split(":")[1]}</title>
{/if}
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="page-title">
                <Link to="inventory/eggs" class="btn btn-second back"><img src={backIcon} alt=""> Back</Link>
            </div>
            <div class="nft-info">
                <Alert />
            </div>
            <div class="row inventory-cards">
                <div class="col-12">
                    <div class="nft-info">
                        <div class="row nft-big-card card-1">
                            <div class="col-lg-6">
                                <div class="nft-name d-md-none">
                                    Egg #{id.split(":")[1]}
                                </div>
                                <div class="nft-img-wrapper">
                                    <img src="/images/eggs/egg-{id.slice(-1)}.png" class="nft-img" alt="nft">
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="nft-content">
                                    <h1 class="nft-name d-none d-md-block">Egg #{id.split(":")[1]}</h1>
                                    {#if !$isLoggedIn || $getNft.value?.userId !== $userProfile.userId}
                                        <div class="owner">
                                            <div class="avatar">
                                                {#if $getNft.hasValue}
                                                    {avatar($getNft.value?.nickname)}
                                                {/if}
                                            </div>
                                            {#if !$getNft.hasValue && $getNft.loading}
                                                Loading...
                                            {:else if !$getNft.hasValue && $getNft.error }
                                                Error
                                            {:else if $getNft.hasValue && $getNft.value?.nickname}
                                                <Link to="marketplace/{$getNft.value?.userId}">
                                                    {$getNft.value.nickname.replace(/#([^#]+)$/, '')}
                                                </Link>
                                            {/if}
                                        </div>
                                    {/if}
                                    <div class="prices">
                                        {#if $getNft.loading}
                                            <div class="price">Loading...</div>
                                        {:else if $getNft.hasValue}
                                            {#if $getNft.value?.additionalParams?.price && $getNft.value?.additionalParams?.currency}
                                                <div class="price">
                                                    <span>{$getNft.value.additionalParams.price} {$getNft.value.additionalParams.currency}</span>
                                                    <!-- ~{Math.round($getNft.value.price*0.135 * 100) / 100} USD-->
                                                </div>
                                            {/if}
                                        {/if}
                                    </div>
                                    {#if !$getNft.hasValue && $getNft.loading}
                                        <button class="buy-btn active-btn" disabled>Loading...</button>
                                    {:else if $getNft.hasValue && $isLoggedIn && $getNft.value?.userId === $userProfile.userId}
                                        {#if $getNft.value?.status === 'approved' && $getNft.value?.isNft}
                                            <button class="buy-btn active-btn mb-3" on:click={() => {
                                                isConfirmedAction.reset()
                                                isConfirmedAction.send()
                                                sellNftModal = true
                                            }}
                                                disabled={loading || opened}>
                                                <span>Sell egg</span>
                                            </button>
                                            <button class="buy-btn active-btn" on:click={() => {openMintModal = true}} disabled={opened}>
                                                <span>Open egg</span>
                                            </button>
                                        {:else if $getNft.value?.status === 'inMarket'}
                                            <button class="buy-btn active-btn" on:click={cancelSellNftHandler} disabled={loading}>
                                                <span>Cancel sale</span>
                                            </button>
                                        {:else}
                                            <button class="buy-btn active-btn" disabled><span>Loading...</span></button>
                                        {/if}
                                    {/if}
                                    <Modal bind:visible={sellNftModal}>
                                        <svelte:fragment slot="content">
                                            <div class="modal-custom__title">Sell egg</div>
                                            {#if !$isConfirmedAction.hasValue && $isConfirmedAction.loading}
                                                <div class="modal-custom__text text-center">Loading...</div>
                                            {:else if !$isConfirmedAction.hasValue && $isConfirmedAction.error}
                                                <div class="modal-custom__text text-center">Something went wrong. Try refreshing the page.</div>
                                            {:else if $isConfirmedAction.hasValue}
                                                {#if !$isConfirmedAction.value}
                                                    <div class="modal-custom__text">
                                                        <p>We have sent an email confirming the marketplace actions</p>
                                                        <div class="text-center">
                                                            <div class="form-group mb-3">
                                                                <input type="text" class="form-control confirm-action-field" bind:value={code} placeholder="Enter code">
                                                                <div class="invalid-feedback mt-2" class:d-block={$confirmAction.error}>{$confirmAction.error}</div>
                                                            </div>
                                                            <button class="btn btn-primary" on:click={confirmActionHandler} class:loading={loading} class:disabled={!code}>
                                                                <span>Confirm</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                {:else}
                                                    <div class="modal-custom__text">
                                                        <div class="nft-mini-img">
                                                            <img src="/images/eggs/egg-{id.slice(-1)}.png" class="modal-nft" alt="nft">
                                                        </div>
                                                        <div class="commission-text">Fees: <span>4%</span></div>
                                                        <div class="commission-text mb-3">You will get: <span class="color-green">
                                                            {amount >= 1 ? roundNumber(amount * 0.96) : '-'} USDT</span>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="input-group justify-content-center">
                                                                <input type="number" class="form-control amount"
                                                                    on:keypress={keyPressSellNft}
                                                                    bind:value={amount} placeholder="Enter amount">
                                                                <span class="input-group-text empty-input-group-text">USDT</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="modal-custom__footer">
                                                        <button class="btn btn-cancel" on:click={() => { sellNftModal = false }}>
                                                            Close
                                                        </button>
                                                        <button class="btn btn-primary" class:loading={loading}
                                                            on:click={sellNftHandler}
                                                            disabled={!amount || amount < minAmount || loading}>
                                                            <span>Submit</span>
                                                        </button>
                                                    </div>
                                                {/if}
                                            {/if}
                                        </svelte:fragment>
                                    </Modal>
                                    <Modal bind:visible={openMintModal}>
                                        <svelte:fragment slot="content">
                                            <div class="modal-custom__title">You got NFT</div>
                                            <div class="modal-custom__text">
                                                <Hatching productId={id} on:opened={handleOpened}/>
                                            </div>
                                        </svelte:fragment>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                        <div class="row nft-page-info">
                            <div class="col-lg-6">
                                <div class="tab">
                                    <IconifyIcon icon={infoIcon} class="tab-icon"/>Information
                                </div>
                                <div class="description">
                                    <p>Type: Egg</p>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="history-column">
                                    <div class="tab">
                                        <IconifyIcon icon={historyIcon} class="tab-icon"/>History
                                    </div>
                                    {#if !$getNftHistory.hasValue && $getNftHistory.loading}
                                        Loading...
                                    {:else if !$getNftHistory.hasValue && $getNftHistory.error}
                                        Something went wrong
                                    {:else if $getNftHistory.hasValue}
                                        {#if $getNftHistory.value.totalCount}
                                            <div class="history-table">
                                                <div class="history-table-header">
                                                    <div>Price</div>
                                                    <div>Owner</div>
                                                    <div>Date</div>
                                                </div>
                                                <div class="history-table-body">
                                                    {#each $getNftHistory.value.items as {
                                                        price, currency, userId, nickname, createdAt }}
                                                        <div class="history-table-row">
                                                            <div>{price} {currency}</div>
                                                            <div>
                                                                <Link to="marketplace/{userId}">
                                                                    {nickname.replace(/#([^#]+)$/, '')}
                                                                </Link>
                                                            </div>
                                                            <div>{getDate(createdAt).toLocaleString()}</div>
                                                        </div>
                                                    {/each}
                                                </div>
                                            </div>
                                            <div class="text-center">
                                                <Pagination
                                                    bind:currentPage={currentPage}
                                                    totalCount={$getNftHistory.value?.totalCount}
                                                    {perPage}
                                                    disabled={!$getNftHistory.hasValue && $getNftHistory.loading}/>
                                            </div>
                                        {:else}
                                            <div class="content-empty">
                                                <div class="title">No data yet</div>
                                                <img src="{emptyList}" alt="">
                                            </div>
                                        {/if}
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .owner {
        margin: 0 0 40px;
        font-size: 20px;
        display: flex;
        align-items: center;
        color: white;
        font-weight: 500;
    }

    .owner .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #282d39;
        margin-right: 12px;
        color: #e9e5e5;
        font-size: 13px;
        text-transform: uppercase;
        cursor: default;
    }

    .nft-content .owner :global(a){
        color: white;
        font-weight: 500;
        text-decoration: none;
        transition: .15s;
    }

    .nft-content .owner :global(a:hover){
        color: #FF5D1C;
    }

    .explore-nft-btn {
        margin: 20px auto 0;
        display: table;
        color: #bbbbbb;
        text-decoration: none;
        border-bottom: 1px solid #bbbbbb;
        font-size: 15px;
        line-height: normal;
        padding-bottom: 1px;
        transition: .25s;
    }

    .explore-nft-btn:hover {
        color: #cccccc;
        border-color: #cccccc;
    }

    .form-control.amount {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
        padding: 10px 15px;
        border-right: 0;
        max-width: 200px;
        border-radius: 8px 0 0 8px;
    }

    .form-control.amount:focus {
        box-shadow: none;
    }

    .form-control.amount:focus,
    .form-control.amount:focus + span {
        border-color: #FF5D1C;
    }

    .commission-text {
        width: 290px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto 8px;
        font-size: 14px;
    }

    .color-green {
        font-weight: 500;
        color: #27AE60;
    }

    .commission-text {
        width: 290px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto 8px;
        font-size: 14px;
    }

    .empty-input-group-text {
        background: none;
        border-left: 0;
        min-width: initial;
        padding: 0 30px;
        font-size: 20px;
        color: #61758A;
        transition: .25s;
    }

    .first-letter {
        text-transform: capitalize;
    }

    .nft-info {
        max-width: 1350px;
    }

    .history-column {
        padding-left: 28px;
    }

    .nft-img-wrapper {
        background: linear-gradient(180deg, #3E2929 -72.66%, #0B0E21 132.58%);
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        border-radius: 20px;
        border: 2px solid #494591;
    }

    .nft-img {
        position: relative;
        width: 100%;
        height: 100%;
        max-height: 530px;
        max-width: 530px;
        object-fit: contain;
        padding: 80px;
        transform: matrix3d(1,-.03,0,.0004,.03,1,-.05,0,0,.05,1,0,5,0,-20,1) scale(0.95);
        transition: .5s;
    }

    .nft-img:hover {
        transform: matrix3d(1,.03,0,-.0004,-.03,1,.05,0,0,-.05,1,0,-5,0,20,1) scale(1.05);
    }

    .nft-mini-img {
        width: 180px;
        height: 180px;
        margin: 0 auto 20px;
        display: block;
        background: #41485e;
        border-radius: 5px;
        padding: 10px;
    }

    .nft-mini-img img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    .nft-info :global(.back) {
        color: white;
        font-size: 20px;
        font-family: 'Anton', sans-serif;
        margin: 50px 0;
        display: table;
        text-decoration: none;
        text-transform: uppercase;
    }

    .nft-info :global(.back img) {
        margin-right: 10px;
        transform: rotate(-90deg);
        transition: .25s;
    }

    .nft-info :global(.back:hover img) {
        transform: rotate(-135deg);
    }

    .nft-name {
        font-size: 40px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: 60px;
        margin-bottom: 20px;
    }

    .nft-content {
        padding: 30px;
        border-radius: 20px;
        margin-left: 16px;
        border: 2px solid #353064;
        background: #26244D;
        height: 100%;
    }

    .nft-big-card {
        margin-bottom: 30px;
    }

    .description {
        font-size: 16px;
        color: white;
        line-height: 24px;
        font-weight: 300;
        margin: 10px 0 30px 0;
    }

    .description p {
        margin-bottom: 10px;
    }

    .price {
        color: #A0AEC0;
        font-size: 20px;
        line-height: 50px;
    }

    .price span {
        color: #FFDB3A;
        font-size: 50px;
        font-weight: 900;
        margin-right: 10px;
    }

    .prices {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 10px;
    }

    :global(.buy-btn) {
        background: #FF5D1C;
        color: white;
        border: 0;
        height: 70px;
        width: 100%;
        border-radius: 3px;
        text-transform: uppercase;
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        letter-spacing: 1px;
        transition: .25s;
    }

    :global(.buy-btn:hover) {
        background: #fb7844;
        color: white;
        text-decoration: none;
    }

    .card-common .label {
        background: #AAAAAA;
    }

    .card-legendary .backdrop {
        background: rgba(255, 156, 0, 0.25);
    }

    .card-legendary .label {
        background: #F0A500;
    }

    .card-uncommon .backdrop {
        background: rgba(39, 174, 96, 0.25);
    }

    .card-uncommon .label {
        background: #27AE60;
    }

    .card-epic .label {
        background: #9B51E0;
    }

    .card-epic .backdrop {
        background: rgba(155, 81, 224, 0.25);
    }

    .card-epic .label {
        background: #9B51E0;
    }

    .card-rare .label {
        background: #2F80ED;
    }

    .card-rare .backdrop {
        background: rgba(47, 128, 237, 0.25);
    }

    .card-rare .label {
        background: #2F80ED;
    }

    .card-relic .label {
        background: linear-gradient(153.33deg, #FF61F6 0%, #FFF61C 176.46%);
    }

    .card-relic .backdrop {
        background: rgba(255, 146, 173, 0.25);
    }

    .tab {
        font-size: 20px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: 26px;
        font-weight: 400;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        padding: 10px 10px 10px 0;
    }

    .nft-page-info :global(.tab-icon) {
        margin-right: 10px;
    }

    .history-table {
        margin: 10px auto 15px;
        max-width: 1174px;
    }

    .history-table-header {
        display: flex;
        width: 100%;
        background: #cad5e0;
        border-radius: 8px 8px 0 0;
    }

    .history-table-header > div {
        width: 33.3%;
        padding: 10px 30px;
        background: #CAD5E0;
        color: #272C33;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
    }

    .history-table-header > div:first-child {
        border-radius: 8px 0 0 0;
    }

    .history-table-header > div:last-child {
        border-radius: 0 8px 0 0;
    }

    .history-table-row {
        border: 1px solid #CAD5E0;
        border-bottom: 0;
        border-radius: 0;
        display: flex;
        width: 100%;
    }

    .history-table-row:last-child {
        border-bottom: 1px solid #CAD5E0;
        border-radius: 0 0 8px 8px;
    }

    .history-table-row > div {
        width: 33.3%;
        padding: 10px 30px;
        font-size: 15px;
        line-height: 20px;
        font-weight: 500;
        display: flex;
        align-items: center;
        color: white;
    }

    .history-table-row :global(a) {
        color: white;
        text-decoration: none;
        text-overflow: ellipsis;
        overflow: hidden;
        transition: .15s;
    }

    .history-table-row :global(a:hover) {
        color: #fb7844;
    }

    .history-column :global(.pagination) {
        justify-content: center;
    }

    .content-empty {
        width: 100%;
        text-align: center;
        padding: 50px 0;
    }

    .content-empty .title {
        color: #b4c1cf;
        font-size: 18px;
        margin: 0 0 20px;
    }

    .content-empty img {
        max-width: 160px;
    }

    .buy-btn[disabled],
    .buy-btn[disabled]:hover {
        background: #fb7844;
        opacity: 0.7;
    }

    .form-control.confirm-action-field {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
        padding: 10px 15px;
        margin: 0 auto;
        text-align: center;
        max-width: 200px;
        border-radius: 8px;
    }

    .form-control.confirm-action-field:focus {
        box-shadow: none;
    }

    .form-control.confirm-action-field:focus {
        border-color: #FF5D1C;
    }

    @media(max-width: 1400px) {
        .price span {
            font-size: 46px;
        }
    }

    @media(max-width: 1199px) {
        .nft-img {
            max-width: 320px;
            max-height: 320px;
        }

        .description {
            margin-bottom: 30px;
        }

        .nft-name {
            font-size: 36px;
            line-height: 50px;
        }

        .price span {
            font-size: 36px;
        }

        .price {
            font-size: 18px;
        }

        :global(.buy-btn) {
            height: 54px;
        }

        .prices {
            margin-bottom: 30px;
        }

        .history-table-row > div {
            padding: 10px;
            font-size: 14px;
        }

        .history-table-header > div {
            padding: 10px;
            font-size: 15px;
        }
    }

    @media(max-width: 991px) {
        .nft-info :global(.back) {
            margin: 40px 0;
        }

        .nft-content {
            padding-left: 30px;
            margin: 20px 0 0;
        }

        .nft-img {
            max-width: 300px;
            max-height: 300px;
        }

        .history-column {
            padding-left: 0;
        }
    }

    @media(max-width: 767px) {
        .nft-img-wrapper {
            height: calc(100vw - 24px);
            width: 100%;
        }

        .nft-img {
            max-width: 100%;
            max-height: 100%;
            padding: 25px;
            transform: none;
        }

        .nft-name {
            font-size: 30px;
            line-height: 45px;
        }

        .nft-info :global(.back) {
            margin: 30px 0;
        }

        .nft-info :global(.back span) {
            display: none;
        }

        .prices {
            flex-wrap: wrap;
            flex-direction: column-reverse;
            justify-content: flex-start;
            align-items: flex-start;
            margin-bottom: 10px;
        }

        .price {
            font-size: 15px;
            flex-wrap: wrap;
            line-height: 36px;
        }

        .price span {
            font-size: 30px;
        }

        .tab:not(:last-child) {
            margin-right: 20px;
        }

        .nft-content {
            padding: 15px;
        }

        .modal-nft {
            width: 160px;
            height: 160px;
        }

        :global(.buy-btn) {
            letter-spacing: 0;
        }

        .content-empty .title {
            font-size: 16px;
        }

        .content-empty img {
            max-width: 140px;
        }

        .commission-text {
            width: 100%;
        }

        .form-control.amount {
            max-width: initial;
        }

        .buy-btn {
            height: 46px;
            font-size: 16px;
        }

        .nft-img:hover {
            transform: none;
        }

        .explore-nft-btn {
            margin: 15px auto 5px;
            font-size: 14px;
        }
    }
</style>
